module.exports = __webpack_public_path__ + "img/22.f74dc81d.jpeg";